import React from 'react';
import PropTypes from 'prop-types';
import { withFieldProps } from 'hooks/useFieldProps';
import classnames from 'classnames';
import ErrorMsg from 'common/ErrorMsg';
import RawHtml from '../common/RawHtml';

const Button = ({ error, fieldDescr, fieldDomId, help, label, name, readOnly }) => (
  <>
    <div className={classnames('form-group', { error })}>
      {/* eslint-disable-next-line react/button-has-type */}
      <button
        className="btn btn-mobile"
        id={fieldDomId}
        name={name}
        disabled={readOnly}
        aria-describedby={
          classnames({
            [`help-${name}`]: help,
            [`error-${name}`]: error,
          }) || undefined
        }
      >
        <RawHtml type="span">{label}</RawHtml>{' '}
        <i className="icon-arrow-thin-right" aria-hidden="true" />
      </button>
      {fieldDescr && <RawHtml type="small">{fieldDescr}</RawHtml>}
      {help && (
        <RawHtml type="span" className="help-text">
          {help}
        </RawHtml>
      )}
    </div>
    <ErrorMsg name={name} />
  </>
);

Button.propTypes = {
  error: PropTypes.bool.isRequired,
  fieldDescr: PropTypes.string.isRequired,
  fieldDomId: PropTypes.string.isRequired,
  help: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  readOnly: PropTypes.bool.isRequired,
};

export default withFieldProps()(Button);
